export var HOUSEHOLD_MONTHLY_INCOME_FORM = 'household-monthly-income-form';
//# sourceMappingURL=constants.js.map